export default __webpack_public_path__ + "static/media/Roboto-Italic.05ae1ca5.ttf";